import { render, staticRenderFns } from "./student.vue?vue&type=template&id=444cfe90&scoped=true"
import script from "./student.vue?vue&type=script&lang=js"
export * from "./student.vue?vue&type=script&lang=js"
import style0 from "./student.vue?vue&type=style&index=0&id=444cfe90&prod&lang=scss&scoped=true"
import style1 from "./student.vue?vue&type=style&index=1&id=444cfe90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444cfe90",
  null
  
)

export default component.exports